import React, { useEffect, useRef, useState } from 'react'
import { Avatar, Button, message, Popover, Spin, Timeline, Typography } from "antd";
import { modifyTimezoneString } from '../components/HR/TimeClock/Util';
import AwsServerService from '../common/util/AwsServerService';
const { Text, Title } = Typography;

export default function ReportBugActivity({ bug }) {

  const [activityData, setActivityData] = useState([]);
  const [activityOpenId, setActivityOpenId] = useState(null);
  const [loading, setLoading] = useState(false);
  const listRef = useRef(null);

  useEffect(() => {
    if (listRef.current) {
      setTimeout(() => {
        listRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      }, 100);
    }
  }, [activityData]);

  const fetchActivity = async (bugId) => {debugger
    setLoading(true);
    try {
      const res = await AwsServerService.getBugActivity(bugId);
      if(!res?.data[0] || res.data[0]?.length === 0) {
        setActivityData([]);
        setLoading(false);
        return;
      }
      setActivityData(res?.data[0]?.sort((a,b) => new Date(b.CREATEDDATE) - new Date(a.CREATEDDATE)) || []);
    } catch {
      setActivityData([]);
    }
    setLoading(false);
  };

  const renderTimeline = () => (
    <div ref={listRef} style={{ overflowY: "auto", minWidth: "30rem",
    maxWidth: "34rem", height: "auto",maxHeight: "25rem", padding: "6px" }}>
      {loading ? (
                <Spin />
              ) :
        <Timeline>
          {activityData.map((item, index) => (
            <Timeline.Item key={index}>
              <Avatar style={{marginRight: "4px"}} src={`https://contacts.zoho.com/file?ID=${item.Owner}&fs=thumb`}/>
              <Text strong>{item.OwnerName}</Text> {item.Message}
              <br />
              <Text type="secondary" style={{ fontSize: 12 }}>
                {modifyTimezoneString(item.CREATEDDATE, "MMM DD YYYY hh:mm A")}
              </Text>
            </Timeline.Item>
          ))}
        </Timeline>}
    </div>
  );

  return (
    <Popover
      content={renderTimeline()}
      rootClassName="activity-popover-bugreport"
      title="Activity"
      trigger="click"
      open={activityOpenId === bug.ROWID}
      onOpenChange={(visible) => {
          if (visible) {
            fetchActivity(bug.ROWID);
            setActivityOpenId(bug.ROWID);
          } else {
            setActivityOpenId(null);
          }
        }}
      >
        <Button color="blue" variant="outlined" size="small">view Activity</Button>
    </Popover>
  )
}
